// The Firestore document id a deal's notes live under.
//
// Notes are stored on the deal document itself (deals/{docId}.notes), so they
// MUST be keyed by the deal's REAL document id — the same `id` the deal was
// loaded with (getDealById returns { id: dealSnap.id, ...data }). Earlier the
// notes UI keyed by `createdat`, which only matches the doc id for deals created
// where the two happen to be equal. For any deal where they differ (e.g. legacy
// or migrated deals), the note was written to a different/phantom document via
// setDoc(..., { merge: true }) — no error, so the UI said "Saved", but the real
// deal never got it and the note vanished on reload.
//
// Prefer `id`; fall back to `createdat` only when `id` is absent (matching the
// existing `deal.id || deal.createdat` hedge elsewhere in the app).
export function dealNotesDocId(deal) {
  return String(deal?.id || deal?.createdat || "");
}
